import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    CommonRoutes,
    FilterType,
} from 'app/enums/common.enums'
import {
    CountriesTableTabs,
} from 'app/enums/domain.enums'
import {
    ContainerCode,
    Currency, OrderTypes,
} from 'app/enums/label.enums'
import {
    HsCodeFilterRequestResponse,
} from 'app/Apps/OrderManagement/ProformaInvoices/HsCode/HsCode.types'
import requests from 'app/requests/HsCode.requests'
import {
    ContainerUnitPriceTable,
} from './ProformaInvoices.types'
import HsCodeUpdate from './HsCodeUpdate'

const config:
    SkyNetTableConfig<keyof ContainerUnitPriceTable | keyof HsCodeFilterRequestResponse> = {
        name: 'containerunitpricerule',
        tabs: [
            {
                name: 'Unit Price',
                url: CommonRoutes.All,
                fields: [
                    {
                        name: 'priority',
                        labelKey: 'ProformaInvoices.priority',
                        reduced: true,
                    },
                    {
                        name: 'containerCodes',
                        labelKey: 'ProformaInvoices.containerCodes',
                        componentName: 'TableMultipleEnumValues',
                        allowedValuesEnum: ContainerCode,
                        reduced: true,
                    },
                    {
                        name: 'currency',
                        labelKey: 'ProformaInvoices.currency',
                        componentName: 'EnumValue',
                        allowedValuesEnum: Currency,
                        filterField: 'currency',
                        filterType: FilterType.Array,
                    },
                    {
                        name: 'orderType',
                        componentName: 'EnumValue',
                        allowedValuesEnum: OrderTypes,
                        filterField: 'orderType',
                        filterType: FilterType.Array,
                        labelKey: 'Order.orderType',
                    },
                    {
                        name: 'countriesCountryName',
                        labelKey: 'ProformaInvoices.countries',
                        filterField: 'countriesCountryName',
                        filterType: FilterType.Array,
                        componentName: 'TableMultipleValues',
                    },
                    {
                        name: 'pricingAccountsCompanyName',
                        labelKey: 'ProformaInvoices.pricingAccounts',
                        filterField: 'pricingAccountsCompanyName',
                        filterType: FilterType.Array,
                        componentName: 'TableMultipleValues',
                    },
                    {
                        name: 'unitValue',
                        labelKey: 'ProformaInvoices.unitValue',
                    },
                ],
            },
            {
                name: 'HS Code',
                url: CountriesTableTabs.HsCode,
                customUrl: requests.filterAllRequest({
                    params: {},
                }).url,
                fields: [
                    {
                        name: 'countryName',
                        labelKey: 'ProformaInvoices.country',
                        reduced: true,
                    },
                    {
                        name: 'code',
                        labelKey: 'ProformaInvoices.hsCode',
                    },
                ],
                formTabs: [{
                    label: 'Data Update',
                    url: CommonRoutes.DataUpdate,
                    Component: HsCodeUpdate,
                }],
            },
        ],
    }

export default config
